import script from "./web-article.vue?vue&type=script&setup=true&lang=js"
export * from "./web-article.vue?vue&type=script&setup=true&lang=js"

import "./web-article.vue?vue&type=style&index=0&id=490b2993&lang=scss"

const __exports__ = script;

export default __exports__